exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon__generic__2N-mH{width:35px;height:35px;padding:0;border:none;color:#6eb7fd;background:#fff;transition-property:border,background,color,opacity;transition-duration:.2s;text-align:center;vertical-align:middle}.icon__generic__2N-mH:hover{color:#3899ec;background:#eaf7ff}.icon__text__1CDKw{margin-left:8px}", ""]);

// exports
exports.locals = {
	"generic": "icon__generic__2N-mH",
	"text": "icon__text__1CDKw"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/shared/components/button/icon/icon.styl
// module id = 960
// module chunks = 0 1 2 3 4